import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, Injectable, ModuleWithProviders } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { AttendeeFeatureRoutingModule } from "./attendee-feature-routing.module";
import { SharedService } from "../../modules/shared/services/shared.service";
import { LocalDataService } from "../../modules/shared/services/local-data.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { AccountService } from "../../modules/shared/services/account.service";
import { EventService } from "../../modules/shared/services/event.service";
import { CatalogService } from "../../modules/shared/services/catalog.service";
import { SessionWidgetService } from "../../modules/shared/services/session-widget.service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { SharedModule } from "../shared-module/shared-module";
import { DragScrollModule } from "ngx-drag-scroll";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { map } from 'rxjs/operators';

import {
    AttendeeFeatureView,
    CatalogContextView,
    FilterSectionView,
    SessionSectionView,
    TabSectionView,
    ListService,
    DefaultDrawerView,
    DefaultPopupView,
    LoginPopupView,
    CartSectionView,
    MyscheduleSectionView,
    ForgotPasswordView,
    ResetPasswordView,
    InstanceSectionView
} from ".";
import {
    CclListModule,
    CclNavigationModule,
    CclSharedModule,
    CclLayoutModule,
    CclPageBuilderModule,
    CclPaletteModule,
    CclTemplateResolverService,
    CclNavbarSecondaryService,
    CclBuilderService,
    CclFormsModule,
    CclMessageService,
    CclQuestionBuilderModule
} from "certain-common-library";
import { CommonModule, DatePipe } from "@angular/common";
import { FullCalendarModule } from "ng-fullcalendar";
import { Ng2SearchPipeModule } from "ng2-search-filter";

import {HttpClient} from '@angular/common/http';

@Injectable()
export class TranslationService implements TranslateLoader {

    constructor(private http: HttpClient, private sharedService: SharedService) { }

    getTranslation(lang: string) {
    return this.http.get(`${lang}`)
    .pipe(map((response: JSON) => {
    return response;
    }));
    }   
}

@NgModule({
    declarations: [
        AttendeeFeatureView,
        CatalogContextView,
        FilterSectionView,
        SessionSectionView,
        TabSectionView,
        DefaultDrawerView,
        DefaultPopupView,
        LoginPopupView,
        CartSectionView,
        MyscheduleSectionView,
        ForgotPasswordView,
        ResetPasswordView,
        InstanceSectionView
    ],
    imports: [
        CommonModule,
        AttendeeFeatureRoutingModule,
        CclListModule,
        CclNavigationModule,
        CclSharedModule,
        CclLayoutModule,
        CclPageBuilderModule,
        CclPaletteModule,
        CclFormsModule,
        CclQuestionBuilderModule,
        FlashMessagesModule.forRoot(),
        SharedModule,
        DragScrollModule,
        SlickCarouselModule,
        NgxSmartModalModule.forRoot(),
        InfiniteScrollModule,
        FullCalendarModule,
        Ng2SearchPipeModule,
        NgxDaterangepickerMd.forRoot(),
        TranslateModule.forRoot({
            loader: {                                   // ngx-translate and the loader module
                provide: TranslateLoader,
                useClass: TranslationService,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        CclTemplateResolverService,
        CclNavbarSecondaryService,
        CclBuilderService,
        CclMessageService,
        ListService,
        SharedService,
        LocalDataService,

        AccountService,
        EventService,
        CatalogService,
        SessionWidgetService,
        DatePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AttendeeFeatureModule {}
